module.exports = __webpack_public_path__ + "img/logo.95028ea5.png";